module.exports = __webpack_public_path__ + "static/media/Galeria_Familiares_2.1fea78fe.jpg";